/* TP-G Follow the Case - interactive board, mystery crate scan, countdown. Reads config from #tpgfc-data (fed by section settings). */
(function(){
  function init(){
    var dataEl=document.getElementById('tpgfc-data');
    if(!dataEl) return;
    var cfg={};
    try{ cfg=JSON.parse(dataEl.textContent)||{}; }catch(e){ cfg={}; }
    var POST=(cfg.posters||[]).filter(function(p){return p;});
    var STATUS=["OPENING","PROFILING","DECODING","SOLVED"];

    /* ---------- LIVE CASE STATUS BOARD ---------- */
    var elRange=document.getElementById('lcsRange');
    if(elRange && POST.length===4){
      var starts=["05","12","19","26"].map(function(d){return new Date("2026-10-"+d+"T00:00:00");});
      var bnow=new Date(), live=-1; for(var i=0;i<4;i++){ if(bnow>=starts[i]) live=i; }
      var nowPct= live<0?2:(live*25+12);

      var elFill=document.getElementById('lcsFill'), elRing=document.getElementById('lcsRing'),
          elDisc=document.getElementById('lcsDisc'), elPoster=document.getElementById('lcsPoster'),
          elPct=document.getElementById('lcsPct'), elStatus=document.getElementById('lcsStatus'),
          elLetters=document.getElementById('lcsLetters'), elThumbs=document.getElementById('lcsThumbs'),
          elNow=document.getElementById('lcsNow'), elPlay=document.getElementById('lcsPlay'),
          elPlayLabel=document.getElementById('lcsPlayLabel'),
          elPlayPath=document.getElementById('lcsPlayIcon').querySelector('path'),
          elCase=document.getElementById('caseStatus');

      var C=2*Math.PI*92;
      elRing.setAttribute('stroke-dasharray', C.toFixed(1));
      elNow.style.left=nowPct+'%';

      var lockSvg='<svg class="lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"></rect><path d="M8 11V8a4 4 0 0 1 8 0v3"></path></svg>';
      var lts=[], ths=[];
      POST.forEach(function(s,idx){
        var sp=document.createElement('span'); sp.className='ltr'; elLetters.appendChild(sp); lts.push(sp);
        var b=document.createElement('button'); b.type='button'; b.className='thumb'; b.setAttribute('aria-label','Jump to '+(s.prod||('Suspect '+(idx+1))));
        var im=new Image(); if(s.src){ im.src=s.src; } im.alt=s.prod||''; im.loading='lazy'; b.appendChild(im);
        b.addEventListener('click',function(){ if(playing) stop(); setP(idx*25+12); });
        elThumbs.appendChild(b); ths.push(b);
      });

      // Clue letters unlock WEEKLY by real date (not by the scrub). Future weeks stay locked.
      var litLetters = live<0 ? 0 : Math.min(4, live+1);
      lts.forEach(function(sp,i){
        if(i<litLetters){ sp.className='ltr on'; sp.innerHTML='<span class="ch">'+(POST[i].letter||'')+'</span>'; }
        else { sp.className='ltr'; sp.innerHTML=lockSvg; }
      });

      var cur=nowPct, iv=null, playing=false;
      var ICON_PLAY='M8 5v14l11-7z', ICON_PAUSE='M8 5h3v14H8zM13 5h3v14h-3z';

      function render(p){
        var wk=Math.min(3,Math.floor(p/25));
        var lit=p<=0?0:Math.min(4,Math.floor(p/25)+1);
        elFill.style.width=p+'%';
        elRing.setAttribute('stroke-dashoffset',(C*(1-p/100)).toFixed(1));
        elPct.textContent=Math.round(p)+'%';
        elStatus.textContent=(p>=100?'SOLVED':STATUS[wk]);
        if(POST[wk].src){ elPoster.src=POST[wk].src; }
        elDisc.style.boxShadow='0 0 56px '+(POST[wk].color||'#E85A9B')+'5c';
        ths.forEach(function(b,i){ b.className='thumb'+(i===wk?' active':'')+(i<lit?' lit':''); });
      }
      function setP(p){ cur=Math.max(0,Math.min(100,p)); elRange.value=cur; render(cur); }
      function stop(){ if(iv){clearInterval(iv);iv=null;} playing=false; elPlayPath.setAttribute('d',ICON_PLAY); elPlayLabel.textContent=(cur>=100?'Replay':'Play'); }
      function start(){
        if(cur>=100){ cur=0; }
        playing=true; elPlayPath.setAttribute('d',ICON_PAUSE); elPlayLabel.textContent='Pause';
        iv=setInterval(function(){ cur+=1.1; if(cur>=100){ cur=100; elRange.value=100; render(100); stop(); return; } elRange.value=cur; render(cur); },38);
      }
      elRange.addEventListener('input',function(){ if(playing) stop(); cur=Number(elRange.value); render(cur); });
      elPlay.addEventListener('click',function(){ if(playing) stop(); else start(); });
      elRange.value=cur; render(cur);
      if(elCase){ elCase.textContent = live<0?'#305 - Opens Oct 5':(live>=3?'#305 - Closing':'#305 - Open'); }
    }

    /* ---------- MYSTERY CRATE: scan ---------- */
    var crate=document.getElementById('crate');
    if(crate){
      var light=document.getElementById('crateLight');
      crate.addEventListener('pointermove',function(e){
        var r=crate.getBoundingClientRect();
        light.style.left=(e.clientX-r.left)+'px';
        light.style.top=(e.clientY-r.top)+'px';
        crate.classList.add('scanning','scanned');
      });
      crate.addEventListener('pointerleave',function(){ crate.classList.remove('scanning'); });
    }

    /* ---------- COUNTDOWN ---------- */
    (function(){
      var dd=document.getElementById('cd-d'),hh=document.getElementById('cd-h'),mm=document.getElementById('cd-m'),ss=document.getElementById('cd-s');
      if(!dd) return;
      var target=new Date(cfg.reveal||'2026-10-31T00:00:00-04:00').getTime();
      if(isNaN(target)) target=new Date('2026-10-31T00:00:00-04:00').getTime();
      function pad(n){ return (n<10?'0':'')+n; }
      function tick(){
        var diff=target-Date.now(); if(diff<0) diff=0;
        var s=Math.floor(diff/1000);
        dd.textContent=pad(Math.floor(s/86400));
        hh.textContent=pad(Math.floor((s%86400)/3600));
        mm.textContent=pad(Math.floor((s%3600)/60));
        ss.textContent=pad(s%60);
      }
      tick(); setInterval(tick,1000);
    })();
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
